import { render, staticRenderFns } from "./ActivationBriefAssetsProvider.vue?vue&type=template&id=e17d8f8e&"
import script from "./ActivationBriefAssetsProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAssetsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports